import React from 'react';

const HowItWorks = () => {
  return (
    <div className="container p-4">
      <h1>How It Works</h1>
      <p>
        Our platform is designed to make it easy for restaurants to register and manage their services while providing a seamless experience for customers. Here's how it works:
      </p>

      <h2>For Restaurants</h2>
      <ol style={{ lineHeight: '1.8' }}>
        <li>
          <strong>Register Your Restaurant:</strong>
          Click on the <strong>"Register Restaurant"</strong> button on the homepage. Fill out the registration form with your restaurant's details, including name, address, contact information, and type of cuisine.
        </li>
        <li>
          <strong>Set Up Your Menu:</strong>
          Once registered, log in to your account and add menu items, including descriptions, prices, and images.
        </li>
        <li>
          <strong>Manage Orders:</strong>
          Use the <strong>"Order Requests"</strong> section to view and manage incoming orders from customers.
        </li>
        <li>
          <strong>Track Performance:</strong>
          Access analytics to track your restaurant's performance, including order history and customer feedback.
        </li>
      </ol>

      <h2>For Customers</h2>
      <ol style={{ lineHeight: '1.8' }}>
        <li>
          <strong>Browse Restaurants:</strong>
          Explore a wide range of restaurants and cuisines available on our platform.
        </li>
        <li>
          <strong>Place an Order:</strong>
          Select your favorite dishes, add them to your cart, and place an order with just a few clicks.
        </li>
        <li>
          <strong>Track Your Order:</strong>
          Use the <strong>"My Orders"</strong> section to track the status of your order in real-time.
        </li>
        <li>
          <strong>Enjoy Your Meal:</strong>
          Sit back and relax while your food is delivered to your doorstep.
        </li>
      </ol>

      <h2>Why Choose Us?</h2>
      <ul style={{ lineHeight: '1.8' }}>
        <li>Easy-to-use platform for both restaurants and customers.</li>
        <li>Wide variety of cuisines and restaurants to choose from.</li>
        <li>Real-time order tracking for a seamless experience.</li>
        <li>Dedicated support for restaurants and customers.</li>
      </ul>

      <p>
        Ready to get started? <strong>Register your restaurant</strong> today or start exploring the best food options near you!
      </p>
    </div>
  );
};

export default HowItWorks;